var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector44325724(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 49,
    viewBox: "0 0 98 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325724",
    d: "M86.2854 47.6098H65.4528H11.5754C8.94136 46.7066 0.354302 43.1419 0.799908 34.7401C1.51841 21.193 18.0415 23.9024 16.6039 22.5477C17.0829 21.193 16.7358 15.4735 21.6326 13.7421C26.5294 12.0107 31.2586 13.7421 33.8447 15.7742C34.4264 16.2313 33.8447 2.90444 45.3385 1.54973C60.4242 -0.228323 61.0528 14.4195 61.861 13.7421C64.0161 11.9358 67.6079 7.95855 75.5099 9.67798C84.1303 11.5537 85.0881 19.6125 84.1303 23.225C82.6935 23.9024 94.1874 22.5477 96.3425 33.3854C97.9588 41.5136 90.5956 45.5777 86.2854 47.6098Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector44325724);
export default __webpack_public_path__ + "static/media/Vector 44325724.139ade475cb62ed3614d3ab79b09c193.svg";
export { ForwardRef as ReactComponent };